export const DEFAULT_DASHBOARD_OVERVIEW = {
  totalUsers: 0,
  newUsersToday: 0,
  totalOrders: 0,
  pendingOrders: 0,
  completedOrdersToday: 0,
  totalBuyers: 0,
  totalRevenue: 0,
  totalWalletBalance: 0,
};

export const DEFAULT_REVENUE_STATS = {
  creditsLast7Days: 0,
  debitsLast7Days: 0,
  creditsLast30Days: 0,
  debitsLast30Days: 0,
  completedValueLast30Days: 0,
  totalWalletBalance: 0,
};

export const DEFAULT_ANALYTICS_OVERVIEW = {
  totalOrders: 0,
  completedOrders: 0,
  cancelledOrders: 0,
  newUsers: 0,
  newVendors: 0,
  periodRevenue: 0,
  completedOrderValue: 0,
};

export const DEFAULT_REVENUE_ANALYTICS = {
  vendorTopUps: 0,
  commissionDebits: 0,
  holdsPlaced: 0,
  holdsReleased: 0,
  successfulVolume: 0,
  completedOrderValue: 0,
};

export const DEFAULT_DEVICE_ANALYTICS = {
  completedOrders: 0,
  averageCompletedPrice: 0,
  totalCompletedValue: 0,
  topSellingDevices: [],
};

export const DEFAULT_BUYER_ANALYTICS = {
  activeBuyers: 0,
  completedOrders: 0,
  avgOrdersPerBuyer: 0,
  topBuyers: [],
};

export const DEFAULT_USER_STATS = {
  totalUsers: 0,
  activeUsers: 0,
  userCount: 0,
  buyerCount: 0,
  newUsersLast30Days: 0,
};

export const DEFAULT_ORDER_STATS = {
  ordersLast30Days: 0,
};
